

import {Comparator} from "./Comparator.js";

window.Comparator = Comparator;


